import React, { FC, ReactNode } from 'react'
import { View } from 'react-native'

import useTheme from '@common/hooks/useTheme'
import { NEUTRAL_BACKGROUND_HOVERED } from '@common/modules/dashboard/screens/styles'
import spacings from '@common/styles/spacings'
import { THEME_TYPES } from '@common/styles/themeConfig'
import common from '@common/styles/utils/common'
import flexbox from '@common/styles/utils/flexbox'
import AlarmIcon from '@common/assets/svg/AlarmIcon'

interface PendingBalanceBadgeProps {
  children: ReactNode
}

const PendingBalanceBadge: FC<PendingBalanceBadgeProps> = ({ children }) => {
  const { theme, themeType } = useTheme()
  const iconColor =
    themeType === THEME_TYPES.DARK ? theme.primaryBackgroundInverted : theme.primaryBackground

  return (
    <View
      style={[
        flexbox.directionRow,
        flexbox.alignCenter,
        spacings.phTy,
        spacings.pvMi,
        spacings.mrTy,
        common.borderRadiusPrimary,
        {
          backgroundColor: NEUTRAL_BACKGROUND_HOVERED,
          minHeight: 28,
          gap: 6
        }
      ]}
    >
      <AlarmIcon color={iconColor} width={13} height={15} />
      {children}
    </View>
  )
}

export default PendingBalanceBadge
